// extracted by mini-css-extract-plugin
export default {"wrapper":"LearningVideo_wrapper__ps--B","fullWidth":"LearningVideo_fullWidth__Jzgze"};